import { ResponsiveLine } from "@nivo/line";
import { Table } from "antd/es";
import React, { useMemo } from "react";


export const TimestepSamplingDistribution = (props) => {
    const { frequencies, averages, overall } = props;

    const chart = useMemo(() => frequencies.map((v, idx) => ({ x: idx, y: v, loss: overall[idx] })), [frequencies]);
    const line = [{ id: "incidence", data: chart }];

    return (<div>
        <div style={{ width: '100%', minHeight: 200, height: 200 }}>
            <ResponsiveLine
                data={line}
                // keys={showBar ? barKeys : undefined}
                // indexBy={showBar ? "x" : undefined}
                margin={{ top: 10, right: 50, bottom: 30, left: 10 }}
                xScale={{ type: 'linear', }}
                yScale={{ type: 'linear' }}
                yFormat={v => `${v}`}
                enableSlices="x"
                curve="linear"
                axisTop={null}
                axisLeft={null}
                animate={false}
                axisRight={{
                    format: '.6f',
                    legendOffset: 0
                }}
                enableGridX={true}
                colors={{ scheme: 'tableau10' }}
                theme={{
                    "tooltip": {
                        "container": {
                            "color": "black"
                        }
                    },
                    "grid": {
                        "line": {
                            "stroke": "#777777"
                        }
                    },
                    "axis": {
                        "domain": {
                            "line": {
                                "stroke": "#777777",
                                "strokeWidth": 1
                            }
                        },
                        // "grid": 6,
                        "legend": {
                            "text": {
                                "fontSize": 12,
                                "fill": "#ff0000",
                                "outlineWidth": 0,
                                "outlineColor": "transparent"
                            }
                        },
                        "ticks": {
                            "text": {
                                "fontSize": 11,
                                "fill": "#c0c0c0",
                                "outlineWidth": 0,
                                "outlineColor": "transparent"
                            }
                        }
                    },
                }}
                lineWidth={1}
                enablePoints={false}
                crosshairType="cross"
                enableTouchCrosshair={true}
                useMesh={false}
                legends={[]} />
        </div>

        <div>
            <Table
                rowKey={"x"}
                size="small"
                dataSource={chart}
                columns={[
                    { title: "Timestep", dataIndex: "x" },
                    { title: "Samples", dataIndex: "y", sorter: (a, b, order) => a.y - b.y },
                    { title: "Avg. loss", dataIndex: "loss", sorter: (a, b, order) => a.loss - b.loss, render: v => v.toFixed(5) }
                ]}
                pagination={{ position: ["bottomCenter"], responsive: true, size: "small" }} />
        </div>
    </div>);
};
